module.exports = __webpack_public_path__ + "img/st.a9d377e.png";